import { Services, Types } from "@sendum/core";
import { Action, ThunkAction } from "@reduxjs/toolkit";
import { AnyAction } from "redux";
import { toast } from "react-hot-toast";

import { DispatchAction, PalletSelectorRootState } from "./PalletSelectorStore";
import { IPalletSelectorState } from "./PalletSelectorReducer";

export enum PalletSelectorActionTypes {
	RESET_STATE,
	END_INITIAL_LOADING,
	SET_ERROR,
	SET_LOADING,
	SET_PALLETS,
	SET_PALLET,
	SET_ACCOUNT,
}

export const resetState = (): DispatchAction => ({
	type: PalletSelectorActionTypes.RESET_STATE,
	payload: {},
});

export const endInitialLoading = (): DispatchAction => ({
	type: PalletSelectorActionTypes.END_INITIAL_LOADING,
	payload: {},
});

export const setError = (error: Error): DispatchAction => ({
	type: PalletSelectorActionTypes.SET_ERROR,
	payload: {
		error,
	},
});

export const setLoading = (isLoading: boolean): DispatchAction => ({
	type: PalletSelectorActionTypes.SET_LOADING,
	payload: {
		isLoading,
	},
});

export const setPallets = (pallets: Types.Pallet[]): DispatchAction => ({
	type: PalletSelectorActionTypes.SET_PALLETS,
	payload: {
		pallets,
	},
});

export const setPallet = (pallet?: Types.Pallet): DispatchAction => ({
	type: PalletSelectorActionTypes.SET_PALLET,
	payload: {
		pallet,
	},
});

export const setAccount = (account?: Types.Account): DispatchAction => ({
	type: PalletSelectorActionTypes.SET_ACCOUNT,
	payload: {
		account,
	},
});

export const loadPallets = (isMovement?: boolean): ThunkAction<void, PalletSelectorRootState, null, Action<string>> => async (dispatch, getState) => {
	const state: IPalletSelectorState = getState().PalletSelector;

	if (state.isLoading) {
		return;
	}

	await dispatch(setLoading(true) as unknown as AnyAction);

	try {
		const response = await Services.API.WidgetsApi.getPallets(isMovement);

		await dispatch(setPallets(response.pallets));
		await dispatch(endInitialLoading());
		await dispatch(setLoading(false));
	} catch (error) {
		toast.error((error as Error).message);
		await dispatch(endInitialLoading());
		await dispatch(setLoading(false));
		await dispatch(setError(error as Error));
	}
};

export const refreshPallets = (isMovement?: boolean): ThunkAction<void, PalletSelectorRootState, null, Action<string>> => async (dispatch, getState) => {
	try {
		const response = await Services.API.WidgetsApi.getPallets(isMovement);
		await dispatch(setPallets(response.pallets));
	} catch (error) {
		toast.error((error as Error).message);
	}
};

export const loadAccount = (): ThunkAction<void, PalletSelectorRootState, null, Action<string>> => async dispatch => {
	try {
		const response = await Services.API.WidgetsApi.getAccount();
		await dispatch(setAccount(response));
	} catch (error) {
		toast.error((error as Error).message);
		await dispatch(setError(error as Error));
	}
};
